import { HTTPRequestMethods } from '../../Shared/httpRequestMethods';
import { convertObjectKeysToSnakeCase } from '../../Shared/ConvertObjectKeysToSnakeCase';
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getJobDescriptionsFromExternalWebsites = ({ onResponse, onError, body }) => {
  const params = new URLSearchParams();
  if (body?.pageNumber) {
    params.append('page_number', body.pageNumber);
  }

  const url = `/api/job_descriptions_from_external_websites${params.toString() ? `?${params.toString()}` : ''}`;

  fetch(
    url,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};


export const deleteJobDescriptionFromExternalWebsite = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_descriptions_from_external_websites/delete_job_description_from_external_website",
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const closeJobDescriptionFromExternalWebsite = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_descriptions_from_external_websites/close_job_description_from_external_website",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateJobDescriptionFromExternalWebsite = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_descriptions_from_external_websites/update_job_description_from_external_website",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const checkIfStillActive = ({ onResponse, onError, jobDescriptionId }) => {
  fetch(
    `/api/job_descriptions_from_external_websites/${jobDescriptionId}/check_if_still_active`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const cacheLineImportance = ({ onResponse, onError, jobDescriptionId }) => {
  fetch(
    `/api/job_descriptions_from_external_websites/${jobDescriptionId}/cache_line_importance`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const reopenJobDescriptionFromExternalWebsite = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_descriptions_from_external_websites/reopen_job_description_from_external_website",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const syncJobBoard = ({ onResponse, onError, jobDescriptionId }) => {
  fetch(
    `/api/job_descriptions_from_external_websites/${jobDescriptionId}/sync_job_board`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const deleteJobDescriptionsWithBlockedTitles = ({ onResponse, onError, body }) => {
  fetch(
    "/api/job_descriptions_from_external_websites/delete_job_descriptions_with_blocked_titles",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const archiveJobDescriptionFromExternalWebsite = ({ onResponse, onError, body }) => {
  fetch(
    `/api/job_descriptions_from_external_websites/${body.jobDescriptionFromExternalWebsiteId}/archive`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};